import { Component, OnInit } from '@angular/core';
import { LangService } from './shared/services/changelang.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {
  currentLanguage: string = '';

  constructor(
    private translate: TranslateService,
    private changeLangService: LangService
  ) {}

  ngOnInit(): void {
    const savedLanguage = localStorage.getItem('language');

    if (!savedLanguage) {
      const defaultLang = this.changeLangService.setDefaultLang();
      this.translate.setDefaultLang(defaultLang);
      this.translate.use(defaultLang);
      this.currentLanguage = defaultLang;
    } else {
      this.changeLangService.setLang(savedLanguage);
      this.translate.use(savedLanguage);
      this.currentLanguage = savedLanguage;
    }


    console.log(environment)
    // Aggiorna lingua se cambiata dinamicamente
    this.changeLangService.languageChanged$.subscribe((language: string) => {
      this.translate.use(language);
      this.currentLanguage = language;
    });
  }
}
